/**
 * Why an automated Cloudflare setup failed. rest-api records one; the dashboard
 * owns the customer copy for each.
 */
export const CF_FAILURE_REASONS = [
  'token_missing_permissions',
  'token_rejected',
  'zone_not_found',
  'zone_not_active',
  'workers_not_enabled',
  'route_collision',
  'ssl_unsafe',
  'ssl_unconfirmed',
  'dns_unreadable',
  'site_unreachable_after_proxy',
  'origin_unknown',
  'worker_limit_reached',
  'workers_subdomain_missing',
  'rate_limited',
  'cloudflare_unreachable',
  'prerender_token_missing',
  'setup_interrupted',
  'setup_failed',
] as const;

export type CfFailureReason = typeof CF_FAILURE_REASONS[number];
